/**
 * @owner @Appboy/whats-app
 */
import { z } from "zod";
import { whatsAppListSchema } from "@schemas/message/whatsAppListSchema";
import { whatsAppResponseMessageCommonSchema } from "@schemas/message/whatsAppResponseMessageCommonSchema";

// refer to WhatsAppResponseMessageListExport
export const whatsAppResponseListMessageSchema = z.object({
  ...whatsAppResponseMessageCommonSchema.shape,
  layout: z.literal("list-message"),
  header_text: z.string().nullable().optional(),
  body: z.string().nullable().optional(),
  footer: z.string().nullable().optional(),
  list: whatsAppListSchema,
});
